module.exports = __webpack_public_path__ + "static/img/HUNTER-WRIGHT.3ee7b7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HUNTER-WRIGHT.jpg
// module id = xZTD
// module chunks = 0